import { type SpecificationParagraphContentType, SpecificationContentType } from '../enums';

/** 正常的流程中说明书所有要生成的段落顺序 */
export const SpecificationGenContentOrder: SpecificationParagraphContentType[] = [
    SpecificationContentType.Title,
    SpecificationContentType.TechField,
    SpecificationContentType.Background,
    SpecificationContentType.Summary,
    SpecificationContentType.Figures,
    SpecificationContentType.FigureDescription,
    SpecificationContentType.EmbodimentOutline,
    SpecificationContentType.Abstract,
    SpecificationContentType.AbstractFigure,
];

/**
 * 所有可能会出现的段落顺序
 * 历史里面有旧版的段落，相比上面的里面不能再出现，但是兼容老数据需要走原流程，所以需要单独列出来
 * 动态加入的段落不在内，例如 SpecificationContentType.EmbodimentItem
 * */
export const SpecificationAllContentOrder: SpecificationParagraphContentType[] = [
    SpecificationContentType.Title,
    SpecificationContentType.TechField,
    SpecificationContentType.Background,
    SpecificationContentType.Summary,
    SpecificationContentType.Figures,
    SpecificationContentType.FigureDescription,
    SpecificationContentType.Embodiment,
    SpecificationContentType.EmbodimentOutline,
    SpecificationContentType.Abstract,
    SpecificationContentType.AbstractFigure,
];

/** 中国专利局说明书标题最大字数 */
export const SpecificationGenContentTitleMaxLengthCNIPAM = 60;
/** 美国专利局说明书标题最大字数 */
export const SpecificationGenContentTitleMaxLengthUSPTO = 500;
/** 欧洲专利局说明书标题最大字数 */
export const SpecificationGenContentTitleMaxLengthEPO = 500;


/** 中国专利局说明书段落标签 */
export const SpecificationContentTypeLabelCNIPAM = {
    [SpecificationContentType.Title]: '标题',
    [SpecificationContentType.TechField]: '技术领域',
    [SpecificationContentType.Background]: '背景技术',
    [SpecificationContentType.Summary]: '发明内容',
    [SpecificationContentType.Embodiment]: '具体实施方式',
    [SpecificationContentType.EmbodimentOutline]: '具体实施方式',
    [SpecificationContentType.EmbodimentItem]: '实施例',
    [SpecificationContentType.Abstract]: '摘要',
    [SpecificationContentType.Figures]: '附图',
    [SpecificationContentType.FigureDescription]: '附图说明',
    [SpecificationContentType.AbstractFigure]: '摘要附图',
};

/** 美国专利局说明书段落标签 */
export const SpecificationContentTypeLabelUSPTO = {
    [SpecificationContentType.Title]: 'TITLE OF INVENTION',
    [SpecificationContentType.TechField]: 'TECHNICAL FIELD',
    [SpecificationContentType.Background]: 'BACKGROUND OF THE INVENTION',
    [SpecificationContentType.Summary]: 'SUMMARY OF THE INVENTION',
    [SpecificationContentType.Embodiment]: 'DETAILED DESCRIPTION OF THE INVENTION',
    [SpecificationContentType.EmbodimentOutline]: 'DETAILED DESCRIPTION OF THE INVENTION',
    [SpecificationContentType.EmbodimentItem]: 'EMBODIMENT',
    [SpecificationContentType.Abstract]: 'ABSTRACT',
    [SpecificationContentType.Figures]: 'FIGURES',
    [SpecificationContentType.FigureDescription]: 'FIGURE DESCRIPTION',
    [SpecificationContentType.AbstractFigure]: 'ABSTRACT FIGURES',
};

/** 欧洲专利局说明书段落标签 */
export const SpecificationContentTypeLabelEPO = {
    [SpecificationContentType.Title]: 'TITLE',
    [SpecificationContentType.TechField]: 'FIELD OF THE INVENTION',
    [SpecificationContentType.Background]: 'BACKGROUND OF THE INVENTION',
    [SpecificationContentType.Summary]: 'SUMMARY OF THE INVENTION',
    [SpecificationContentType.Embodiment]: 'DETAILED DESCRIPTION OF THE INVENTION',
    [SpecificationContentType.EmbodimentOutline]: 'DETAILED DESCRIPTION OF THE INVENTION',
    [SpecificationContentType.EmbodimentItem]: 'EMBODIMENT',
    [SpecificationContentType.Abstract]: 'ABSTRACT',
    [SpecificationContentType.Figures]: 'FIGURES',
    [SpecificationContentType.FigureDescription]: 'FIGURE DESCRIPTION',
    [SpecificationContentType.AbstractFigure]: 'ABSTRACT FIGURES',
};

/** 中国专利局图片序号前缀 */
export const FigurePrefixCNIPAM = '图';

/** 美国专利局图片序号前缀 */
export const FigurePrefixUSPTO = 'Fig.';

/** 欧洲专利局图片序号前缀 */
export const FigurePrefixEPO = 'Fig.';
